<template>
  <div class="summary-wrapper">
    <div class="form-row">
      <div class="columns">
        <div>
          <div class="success-box">
            <h2 v-html="$t('view.component.topup.single.pending.header')"></h2>
            <p v-html="$t('view.component.topup.single.pending.text1')"></p>
          </div>
          <div class="desc">
            <p v-html="$t('view.component.topup.single.pending.text2')" class="bold"></p>
            <p v-html="$t('view.component.topup.single.pending.text3')"></p>
            <p v-html="$t('view.component.topup.single.pending.text4')"></p>
            <p v-html="$t('view.component.topup.single.pending.text5', {orderId: transaction.orderId})"></p>
            <p v-html="$t('view.component.topup.single.pending.text6')" class="thank-you"></p>
          </div>
        </div>
        <div class="phones-wrapper" v-if="topups">
          <TopupSinglePartialTopupPhonesBox :topups="topups" />
          <p class="bold hint-field default">
            <a href="https://faktury.autopay.pl/" target="_blank">{{ $t('view.component.topup.single.success.invoiceLink') }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'
import TopupSinglePartialTopupPhonesBox from '@/orange/components/Topup/Single/PartialTopupPhonesBox'

export default {
  name: 'TopupSinglePending',
  components: { TopupSinglePartialTopupPhonesBox },
  props: {
    transaction: {
      type: Object,
      required: false,
      default: null
    },
    topups: {
      type: Array,
      required: false,
      default: null
    }
  },
  methods: {
    goToTopup () {
      this.$router.push(ROUTING.topup.single.step1)
    }
  }
}
</script>
<style lang="scss" src="../../../assets/scss/components/_topup-summary.scss" scoped></style>
